import { useEffect, useState } from 'react';

function useSearchTermUrl(searchTerm: string): boolean {

    const [searchTermExistsInUrl, setSearchTermExistsInUrl] = useState(false)

    useEffect(() => {
        const currentUrl = window.location.href

        const exists = currentUrl.includes(searchTerm)

        setSearchTermExistsInUrl(exists)
    }, [searchTerm])

    return searchTermExistsInUrl

}

export default useSearchTermUrl
